import MenuPosition from 'models/application/menu/position/Position';

export default class LogoMenuPosition extends MenuPosition {
	constructor(position) {
		super(position);

		this.mobileImage = position.mobile_image;
	}
}
